import React from 'react'
import { useSvgDrawing } from 'react-hooks-svgdrawing'

export const Drawing = (): JSX.Element => {
  const [renderRef] = useSvgDrawing({
    penColor: '#FF0000',
    penWidth: 3,
    background: 'rgba(255, 255, 255, 0.0)'
  })
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 100
      }}
      ref={renderRef}
    />
  )
}

export default Drawing
